<template>
  <div>
    <section class="bg-blue" v-if="this.$store.getters.getUser['education_loan']">
      <div class="education-loan-form bg-white" id="sd">
        <div class="row">
          <div class="col-md-12">
            <div class="form-start">
              <form id="education-loan-form">
                <div class="tab">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="main-heading">Education Loan</h1>
                    </div>
                  </div>
                  <div class="col-md-12 padd-20">
                    <div class="form-group">
                      <label for="applicant-name" class="input-group-text">
                        Name of Applicant (Student Name)
                      </label>
                      <input type="text" class="form-control field-req" id="applicant-name"
                             placeholder="Enter Full Name" name="applicant_name"
                             :value="this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name']">
                    </div>
                  </div>
                  <div class="col-md-12 padd-20">
                    <div class="form-group">
                      <label for="number" class="input-group-text">
                        Date Of Birth
                      </label>
                      <div class="input-group date datepicker3" data-provide="datepicker">
                        <input type="text" class="form-control field-req" name="applicant_dob"
                               placeholder="Enter DOB">
                        <div class="input-group-addon">
                          <span class=""><i class="fas fa-calendar-alt"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 padd-20">
                    <div class="form-group">
                      <label class="input-group-text">
                        Current city where you live
                      </label>
                      <input type="text" id="cities" name="applicant_current_city"
                             class="form-control field-req" autocomplete="off" placeholder="City or State"
                             :value="this.$store.getters.getUser['city']"/>
                    </div>
                  </div>
<!--                  <div class="col-md-12 padd-20">-->
<!--                    <div class="form-group">-->
<!--                      <div class="radio-heading input-group-text">-->
<!--                        Which degree do you want to pursue-->
<!--                      </div>-->
<!--                      <select class="form-control field-req" name="degree">-->
<!--                        <option value="">Select Degree</option>-->
<!--                        <option value="Diploma">Diploma</option>-->
<!--                        <option value="Graduation">Graduation</option>-->
<!--                        <option value="Post Graduation">Post Graduation</option>-->
<!--                        <option value="Professional Course">Professional Course</option>-->
<!--                        <option value="Others">Others</option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="col-md-12 padd-20">
                    <div class="form-group">
                      <label for="number" class="input-group-text">
                        Course Name
                      </label>
                        <div class="search-bar" id="course-list-main">
                            <input type="text" class="form-control field-req" id="course-list" name="course_name" placeholder="Enter Course Name">
                            <ul class="college-list"></ul>
                        </div>
<!--                      <select class="form-control field-req" name="college_course_enc_id">-->
<!--                        <option value="">Select Course</option>-->
<!--                        <option v-for="cl in courses" :value="cl.assigned_college_enc_id">-->
<!--                          {{ cl.course_name }}-->
<!--                        </option>-->
<!--                      </select>-->
                    </div>
                  </div>
                  <div class="col-md-6 padd-20">
                    <div class="form-group">
                      <div class="radio-heading input-group-text">
                        Year
                      </div>
                      <select class="form-control field-req" name="years">
                        <option value="">Select Year</option>
                        <option value="1">1st Year</option>
                        <option value="2">2nd Year</option>
                        <option value="3">3rd Year</option>
                        <option value="4">4th Year</option>
                        <option value="5">5th Year</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6 padd-20">
                    <div class="form-group">
                      <div class="radio-heading input-group-text">
                        Semester
                      </div>
                      <select class="form-control field-req" name="semesters">
                        <option value="">Select Semester</option>
                        <option value="1">1st Semester</option>
                        <option value="2">2nd Semester</option>
                        <option value="3">3rd Semester</option>
                        <option value="4">4th Semester</option>
                        <option value="5">5th Semester</option>
                        <option value="6">6th Semester</option>
                        <option value="7">7th Semester</option>
                        <option value="8">8th Semester</option>
                        <option value="9">9th Semester</option>
                        <option value="10">10th Semester</option>
                      </select>
                    </div>
                  </div>
                    <div class="col-md-12 padd-20">
                        <div class="form-group">
                            <label for="annulIncome" class="input-group-text">
                                Loan Amount Required
                            </label>
                            <input type="text" class="form-control field-req" id="annulIncome"
                                   placeholder="Enter Loan Amount" name="amount">
                        </div>
                    </div>
                  <div class="col-md-12 padd-20">
                    <div class="form-group">
                      <label for="number" class="input-group-text">
                        Phone Number (WhatsApp & Call)
                      </label>
                      <input type="text" class="form-control field-req" id="number"
                             placeholder="Enter Phone Number" name="phone"
                             :value="this.$store.getters.getUser['phone']">
                    </div>
                  </div>
                  <div class="col-md-12 padd-20">
                    <div class="form-group">
                      <label for="email" class="input-group-text">
                        Email Address
                      </label>
                      <input type="text" class="form-control field-req" id="email"
                             placeholder="Enter Email Address" name="email"
                             :value="this.$store.getters.getUser['email']">
                    </div>
                  </div>
                </div>

                <div class="tab">
                  <div class="row">
                    <div class="col-md-12">
                      <h1 class="main-heading">Additional Details</h1>
                    </div>
                  </div>


                  <!--                                    <div class="col-md-12 padd-20">-->
                  <!--                                        <div class="form-group ">-->
                  <!--                                            <div class="radio-heading input-group-text">-->
                  <!--                                                Loan Type-->
                  <!--                                            </div>-->
                  <!--                                            <ul class="displayInline">-->
                  <!--                                                <li v-for="lt in loan_types">-->
                  <!--                                                    <label class="container-radio">{{lt.loan_name}}-->
                  <!--                                                        <input type="radio" name="loan_type_enc_id" :value="lt.loan_type_enc_id" @change="getInstructions()">-->
                  <!--                                                        <span class="checkmark"></span>-->
                  <!--                                                    </label>-->
                  <!--                                                </li>-->
                  <!--                                            </ul>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
<!--                  <div class="col-md-12 padd-20">-->
<!--                    <div class="form-group ">-->
<!--                      <div class="radio-heading input-group-text">-->
<!--                        Gender-->
<!--                      </div>-->
<!--                      <ul class="displayInline">-->
<!--                        <li>-->
<!--                          <label class="container-radio">Male-->
<!--                            <input type="radio" checked="checked" name="gender" value="1">-->
<!--                            <span class="checkmark"></span>-->
<!--                          </label>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                          <label class="container-radio">Female-->
<!--                            <input type="radio" name="gender" value="2">-->
<!--                            <span class="checkmark"></span>-->
<!--                          </label>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="col-md-12 padd-20">-->
<!--                    <div class="form-group">-->
<!--                      <label for="adharNumber" class="input-group-text">-->
<!--                        Aadhaar Card Number-->
<!--                      </label>-->
<!--                      <input type="text" class="form-control field-req adhar" id="adharNumber"-->
<!--                             placeholder="Enter 12 digits Aadhaar Card Number" name="aadhaar_number">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="col-md-12 padd-20" v-if="fee_components.length">-->
<!--                    <div class="form-group">-->
<!--                      <div class="radio-heading input-group-text">-->
<!--                        Purpose Of Loan (select at least one)-->
<!--                      </div>-->
<!--                      <ul>-->
<!--                        <li class="service-list" v-for="pl in fee_components">-->
<!--                          <input type="checkbox" name="purpose" :id="pl.fee_component_enc_id"-->
<!--                                 class="checkbox-input services" :value="pl.fee_component_enc_id"/>-->
<!--                          <label :for="pl.fee_component_enc_id">{{ pl.name }}</label>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                      <div class="error-msg" v-html="purposeError"></div>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="applicantsMultiple">
                    <div class="col-md-12 padd-20">
                      <div class="form-heading">
                        Principal Borrower Details
                      </div>
                    </div>
                    <div class="col-md-12 padd-20">
                      <div class="form-group">
                        <label for="coBorrowr-name" class="input-group-text">
                          Name
                        </label>
                        <input type="text" class="form-control field-req co-field" id="coBorrowr-name"
                               placeholder="Enter Full Name" name="name" data-name="name">
                      </div>
                    </div>
                    <div class="col-md-12 padd-20">
                      <div class="form-group">
                        <div class="radio-heading input-group-text">
                          Relation
                        </div>
                        <ul>
                          <li class="service-list">
                            <input type="radio" name="relation" id="father"
                                   class="checkbox-input services co-field" value="Father"
                                   data-name="relation" checked/>
                            <label for="father">Father</label>
                          </li>
                          <li class="service-list">
                            <input type="radio" name="relation" id="mother"
                                   class="checkbox-input services co-field" value="Mother"
                                   data-name="relation"/>
                            <label for="mother">Mother</label>
                          </li>
                          <li class="service-list">
                            <input type="radio" name="relation" id="brother"
                                   class="checkbox-input services co-field" value="Brother"
                                   data-name="relation"/>
                            <label for="brother">Brother</label>
                          </li>
                          <li class="service-list">
                            <input type="radio" name="relation" id="sister"
                                   class="checkbox-input services co-field" value="Sister"
                                   data-name="relation"/>
                            <label for="sister">Sister</label>
                          </li>
                          <li class="service-list">
                            <input type="radio" name="relation" id="guardian"
                                   class="checkbox-input services co-field" value="Guardian"
                                   data-name="relation"/>
                            <label for="guardian">Guardian</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-12 padd-20">
                      <div class="form-group">
                        <div class="radio-heading input-group-text">
                          Employment type ?
                        </div>
                        <ul class="displayInline">
                          <li>
                            <label class="container-radio">Salaried
                              <input type="radio" checked="checked" name="employment_type"
                                     value="1" class="co-field"
                                     data-name="employment_type">
                              <span class="checkmark"></span>
                            </label>
                          </li>
                          <li>
                            <label class="container-radio">Self-Employed
                              <input type="radio" name="employment_type" value="2"
                                     class="co-field" data-name="employment_type">
                              <span class="checkmark"></span>
                            </label>
                          </li>
                          <li>
                            <label class="container-radio">Non-Working
                              <input type="radio" name="employment_type" value="0"
                                     class="co-field" data-name="employment_type">
                              <span class="checkmark"></span>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </div>
<!--                    <div class="col-md-12 padd-20">-->
<!--                      <div class="form-group">-->
<!--                        <label for="coAnnual_income" class="input-group-text">-->
<!--                          Pan Card Number-->
<!--                        </label>-->
<!--                        <input type="text" class="form-control field-req co-field" id="PanNumber"-->
<!--                               name="pan_number" data-name="pan_number"-->
<!--                               placeholder="Enter Pan Number">-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-md-12 padd-20">-->
<!--                      <div class="form-group">-->
<!--                        <label for="coAadhaar_number" class="input-group-text">-->
<!--                          Aadhaar Card-->
<!--                        </label>-->
<!--                        <input type="text" class="form-control field-req co-field adhar" id="coAadhaar_number"-->
<!--                               name="coAadhaar_number" data-name="aadhaar_number"-->
<!--                               placeholder="Enter Aadhaar Card">-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="col-md-12 padd-20">
                      <div class="form-group">
                        <label for="annulIncome" class="input-group-text">
                          Annual Income
                        </label>
                        <input type="text" class="form-control field-req co-field" id="annual_income"
                               name="annual_income" data-name="annual_income"
                               placeholder="Enter Annual Income">
                      </div>
                    </div>
                  </div>
                  <!--                                    <div class="applicantsMultiple">-->
                  <!--                                        <div class="col-md-12 padd-20">-->
                  <!--                                            <div class="form-heading">-->
                  <!--                                               Co-Borrower Details <span>Female Only</span>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                        <div class="col-md-12 padd-20">-->
                  <!--                                            <div class="form-group">-->
                  <!--                                                <label for="coBorrowerFemale" class="input-group-text">-->
                  <!--                                                    Name-->
                  <!--                                                </label>-->
                  <!--                                                <input type="text" class="form-control field-req co-field" id="coBorrowerFemale"-->
                  <!--                                                       placeholder="Enter Full Name" name="name" data-name="name">-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                        <div class="col-md-12 padd-20">-->
                  <!--                                            <div class="form-group">-->
                  <!--                                                <div class="radio-heading input-group-text">-->
                  <!--                                                    Relation-->
                  <!--                                                </div>-->
                  <!--                                                <ul>-->

                  <!--                                                    <li class="service-list">-->
                  <!--                                                        <input type="radio" name="2relation" id="coMother" class="checkbox-input services co-field" value="Mother" data-name="relation" checked/>-->
                  <!--                                                        <label for="coMother">Mother</label>-->
                  <!--                                                    </li>-->
                  <!--                                                    <li class="service-list">-->
                  <!--                                                        <input type="radio" name="2relation" id="coSister"-->
                  <!--                                                               class="checkbox-input services co-field" value="Sister"-->
                  <!--                                                               data-name="relation"/>-->
                  <!--                                                        <label for="coSister">Sister</label>-->
                  <!--                                                    </li>-->
                  <!--                                                    <li class="service-list">-->
                  <!--                                                        <input type="radio" name="2relation" id="coOther"-->
                  <!--                                                               class="checkbox-input services co-field" value="Sister"-->
                  <!--                                                               data-name="relation"/>-->
                  <!--                                                        <label for="coOther">Other</label>-->
                  <!--                                                    </li>-->
                  <!--                                                </ul>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->

                  <!--                                        <div class="col-md-12 padd-20">-->
                  <!--                                            <div class="form-group">-->
                  <!--                                                <div class="radio-heading input-group-text">-->
                  <!--                                                    Employment type ?-->
                  <!--                                                </div>-->
                  <!--                                                <ul class="displayInline">-->
                  <!--                                                    <li>-->
                  <!--                                                        <label class="container-radio">Salaried-->
                  <!--                                                            <input type="radio" checked="checked" name="2employment_type"-->
                  <!--                                                                   value="1" class="co-field"-->
                  <!--                                                                   data-name="employment_type">-->
                  <!--                                                            <span class="checkmark"></span>-->
                  <!--                                                        </label>-->
                  <!--                                                    </li>-->
                  <!--                                                    <li>-->
                  <!--                                                        <label class="container-radio">Self-Employed-->
                  <!--                                                            <input type="radio" name="2employment_type" value="2"-->
                  <!--                                                                   class="co-field" data-name="employment_type">-->
                  <!--                                                            <span class="checkmark"></span>-->
                  <!--                                                        </label>-->
                  <!--                                                    </li>-->
                  <!--                                                    <li>-->
                  <!--                                                        <label class="container-radio">Non-Working-->
                  <!--                                                            <input type="radio" name="2employment_type" value="0"-->
                  <!--                                                                   class="co-field" data-name="employment_type">-->
                  <!--                                                            <span class="checkmark"></span>-->
                  <!--                                                        </label>-->
                  <!--                                                    </li>-->
                  <!--                                                </ul>-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                        <div class="col-md-12 padd-20">-->
                  <!--                                            <div class="form-group">-->
                  <!--                                                <label for="coAnnual_income" class="input-group-text">-->
                  <!--                                                    Pan Card Number (Optional)-->
                  <!--                                                </label>-->
                  <!--                                                <input type="text" class="form-control co-field" id="PanNumber2"-->
                  <!--                                                       name="pan_number" data-name="pan_number"-->
                  <!--                                                       placeholder="Enter Pan Number">-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                        <div class="col-md-12 padd-20">-->
                  <!--                                            <div class="form-group">-->
                  <!--                                                <label for="coAnnual_income" class="input-group-text">-->
                  <!--                                                    Annual Income-->
                  <!--                                                </label>-->
                  <!--                                                <input type="text" class="form-control field-req co-field" id="coAnnual_income"-->
                  <!--                                                       name="annual_income" data-name="annual_income"-->
                  <!--                                                       placeholder="Enter Annual Income">-->
                  <!--                                            </div>-->
                  <!--                                        </div>-->
                  <!--                                    </div>-->
                  <div id="addAnotherCo">

                  </div>
                  <div class="col-md-12 padd-20 displayFlex" id="addAnotherButton">
                    <button type="button" class="addAnotherCo input-group-text" @click="addAnotherCo()">
                      <i class="fas fa-plus-square"></i> Add Co-Borrower(you can add one or more co borrower)
                    </button>
                  </div>
                </div>
                <div class="input-group padd-20">
                  <div class="btn-center">
                    <button type="button" class="button-slide" id="prevBtn" @click="nextPrev(-1)">
                      Previous
                    </button>
                    <button type="button" class="button-slide" id="nextBtn" @click="nextPrev(1)">
                      Next
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="college-logo" id="cl">
        <div class="row">
          <div class="col-md-12">
            <div class="el-pos-rel">
              <div class="max-300">
                <div class="cl-heading">Get the Best Education Loan</div>
                <div class="cl-text"> We tie up with the best providers in the country to help you plan
                  your
                  education.
                  With offers that provide up to 100% of your required loan amount, planning for your
                  education
                  is now more easier than ever.
                </div>
                <div class="cl-icon">
                  <img src="https://shshank.eygb.me/assets/themes/ey/images/pages/educational-loans/edu-loan-icon.png"
                       alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import toastr from "../../../public/js/toastr";
import Autocomplete from '@trevoreyre/autocomplete-js';
import {paymentAccessToken} from "../../_helpers/apiRoute.js";
import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

export default {
  data: function () {
    return {
        currentTab: 0,
        courses: [],
        purposeError: '',
        fee_components: '',
        loan_types: '',
        valid: false,
        coLength: 1,
        payment_id:'',
        education_loan_payment_enc_id:'',
        loan_app_enc_id:'',
    }
  },
  methods: {
    matchHeight() {
      var divHeight = document.getElementById('sd').offsetHeight;
      document.getElementById('cl').style.height = (divHeight + "px");
    },
    paymentPage(paymentId, loanPaymentId, loanAppId) {
      var t = this;
        var options = {
            "key": paymentAccessToken(), // Enter the Key ID generated from the Dashboard
            "name": "MyEcampus",
            "description": "Education Loan Application Fee",
            // "image": "https://example.com/your_logo",
            "order_id": paymentId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "handler": function (response){
                // alert(response.razorpay_payment_id);
                // alert(response.razorpay_order_id);
                // alert(response.razorpay_signature)
                t.updateApplication(response.razorpay_payment_id,response.razorpay_signature, loanPaymentId, loanAppId,'captured');
            },
        };
        var rzp1 = new Razorpay(options);
        rzp1.open();
        rzp1.on('payment.failed', function (response){
            t.updateApplication('','', loanPaymentId, loanAppId,'failed');
            // alert(response.error.code);
            // alert(response.error.description);
            // alert(response.error.source);
            // alert(response.error.step);
            // alert(response.error.reason);
            // alert(response.error.metadata);
        });
      // Layer.checkout({
      //       token: paymentId,
      //       accesskey: paymentAccessToken(),
      //     },
      //     function (response) {
      //       t.updateApplication(response, loanPaymentId, loanAppId);
      //       if (response.status == "captured") {
      //         // response.payment_token_id
      //         // response.payment_id
      //       } else if (response.status == "created") {
      //       } else if (response.status == "pending") {
      //       } else if (response.status == "failed") {
      //
      //       } else if (response.status == "cancelled") {
      //       }
      //     },
      //     function (err) {
      //       console.log(err)
      //       //integration errors
      //     }
      // );
    },
    showTab(n) {
      // This function will display the specified tab of the form...
      var x = document.getElementsByClassName("tab");
      x[n].style.display = "block";
      if (n == 0) {
        document.getElementById("prevBtn").style.display = "none";
        x[n + 1].style.display = "none";
      } else {
        document.getElementById("prevBtn").style.display = "inline";
      }
      if (n == (x.length - 1)) {
        document.getElementById("nextBtn").innerHTML = "Submit";
      } else {
        document.getElementById("nextBtn").innerHTML = "Next";
      }
    },
    nextPrev(n) {
        var t = this;
        if(t.payment_id != ''){
            t.paymentPage(t.payment_id, t.education_loan_payment_enc_id, t.loan_app_enc_id);
            return false;
        }
      var url = this.$store.getters.getDomain;

      var x = document.getElementsByClassName("tab");
      if (n == 1 && !t.validateForm()) {
        return false;
      }

      if (t.currentTab + n < x.length && t.currentTab + n != x.length) {
        x[t.currentTab].style.display = "none";
        t.currentTab = t.currentTab + n;
        t.matchHeight();
        t.showTab(t.currentTab);
      } else {
        var elements = document.getElementById('education-loan-form').elements;
        var obj = {};
        for (var i = 0; i < elements.length; i++) {
          var item = elements.item(i);
          var itemType = elements.item(i).getAttribute('type');
          if (itemType != "radio") {
            if (item.name != "") {
              obj[item.name] = item.value;
            }
          } else {
            if (elements.item(i).checked) {
              obj[item.name] = item.value;
            }
          }
        }
        var elementsMainMultiple = document.getElementsByClassName('applicantsMultiple');
        var data_arr = [];
        for (var j = 0; j < elementsMainMultiple.length; j++) {
          var elementsMultiple = elementsMainMultiple[j].querySelectorAll('.co-field');
          var appObj = {}
          for (var i = 0; i < elementsMultiple.length; i++) {
            var el = elementsMultiple[i];
            var item = el.getAttribute('data-name');
            var type = el.getAttribute('type');
            var itemVal = el.value;
            if (type != 'radio') {
              appObj[item] = itemVal;
            } else {
              if (elementsMultiple[i].checked) {
                appObj[item] = itemVal;
              }
            }
          }
          data_arr.push(appObj);
        }
        obj['co_applicants'] = data_arr;
        // var purpose_arr = [];
        // var el_purpose = document.getElementsByName('purpose');
        // for (var k = 0; k < el_purpose.length; k++) {
        //   if (el_purpose[k].checked) {
        //     purpose_arr.push(el_purpose[k].value);
        //   }
        // }
        // if (!purpose_arr.length && t.fee_components.length) {
        //   t.purposeError = "Choose at least one.";
        //   return false;
        // } else {
        //   t.purposeError = "";
        // }
        // obj['purpose'] = purpose_arr;
        showLoader();
        axios.post(`${url}api/v2/loans/save-applicants`, obj, {headers: requestHeaders()})
            .then(res => {
              hideLoader();
              if (res['data']['response']['status'] == 200) {
                if (res['data']['response']['data'].payment_id != '') {
                    t.payment_id = res['data']['response']['data'].payment_id;
                    t.education_loan_payment_enc_id = res['data']['response']['data'].education_loan_payment_enc_id;
                    t.loan_app_enc_id = res['data']['response']['data'].loan_app_enc_id;
                    t.paymentPage(res['data']['response']['data'].payment_id, res['data']['response']['data'].education_loan_payment_enc_id, res['data']['response']['data'].loan_app_enc_id);
                } else {
                  toastr.success('You have been registered successfully', 'Success');
                  t.$router.push({path: '/dashboard'});
                  return false;
                }
              } else {
                toastr.error('Something went wrong. Please try again.', 'Oops!!');
                return false;
              }
            }).catch(function (error) {
          hideLoader();
          toastr.error('Something went wrong. Please try again.', 'Oops!!');
        })
      }
    },
    validateForm: function () {
      var x, y, z, i, valid = true, a = this;
      x = document.getElementsByClassName("tab");
      y = x[a.currentTab].getElementsByClassName("field-req");
      for (i = 0; i < y.length; i++) {
        if (y[i].value == "") {
          y[i].className += " invalid";
          valid = false;
        } else {
          y[i].classList.remove('invalid');
        }
      }
      var w = x[a.currentTab].getElementsByClassName("adhar");
      if (w.length) {
        for (i = 0; i < w.length; i++) {
          var max_chars = 12,
              regexp = /^\d+$/gs;
          if (w[i].value.length != max_chars || !regexp.test(w[i].value)) {
            w[i].className += " invalid";
            valid = false;
          } else {
            w[i].classList.remove('invalid');
          }
        }
      }
      // function limit(element)
      // {
      //   if(element.value.length > max_chars) {
      //     element.value = element.value.substr(0, max_chars);
      //   }
      //   if (!regexp.test(element.value)) {
      //     alert("Only numbers!");
      //     return false;
      //   }
      // }
      // z = x[a.currentTab].getElementsByTagName('select');
      // if (z.length > 0) {
      //     for (i = 0; i < z.length; i++) {
      //         if (z[i].value == "") {
      //             z[i].className += " invalid";
      //             valid = false;
      //         } else {
      //             z[i].classList.remove('invalid');
      //         }
      //     }
      // }
      // if (a.currentTab == 0) {
      //     if (document.getElementById('password').value != document.getElementById('con_password').value) {
      //         document.getElementById('password').className += " invalid";
      //         document.getElementById('con_password').className += " invalid";
      //         valid = false;
      //     }
      // }
      return valid;
    },
    addAnotherCo() {
      var t = this;
      var coApplicant = ['<div class="col-md-12 padd-20"><span class="form-heading">Add Co-Borrower\'s Details</span><button type="button" class="addAnotherCo input-group-text float-right removeCo" style="float: right;"> Remove</button>\n' +
      '                                    </div>\n' +
      '                                    <div class="col-md-12 padd-20">\n' +
      '                                        <div class="form-group">\n' +
      '                                            <label for="email" class="input-group-text">\n' +
      '                                                Co-Borrower\'s Name\n' +
      '                                            </label>\n' +
      '                                            <input type="text" name="name' + t.coLength + '" data-name="name" class="form-control co-field field-req" id="email"\n' +
      '                                                   placeholder="Enter Full Name">\n' +
      '                                        </div>\n' +
      '                                    </div>\n' +
      '                                    <div class="col-md-12 padd-20">\n' +
      '                                        <div class="form-group">\n' +
      '                                            <div class="radio-heading input-group-text">\n' +
      '                                                Who would be your Co-Borrower?\n' +
      '                                            </div>\n' +
      '                                            <ul>\n' +
      '                                                <li class="service-list">\n' +
      '                                                    <input type="radio" name="relation' + t.coLength + '" data-name="relation" id="father' + t.coLength + '"\n' +
      '                                                           class="checkbox-input services co-field" value="Father" checked/>\n' +
      '                                                    <label for="father' + t.coLength + '">Father</label>\n' +
      '                                                </li>\n' +
      '                                                <li class="service-list">\n' +
      '                                                    <input type="radio" name="relation' + t.coLength + '" data-name="relation" id="mother' + t.coLength + '"\n' +
      '                                                           class="checkbox-input services co-field" value="Mother"/>\n' +
      '                                                    <label for="mother' + t.coLength + '">Mother</label>\n' +
      '                                                </li>\n' +
      '                                                <li class="service-list">\n' +
      '                                                    <input type="radio" name="relation' + t.coLength + '" data-name="relation" id="brother' + t.coLength + '"\n' +
      '                                                           class="checkbox-input services co-field" value="Brother"/>\n' +
      '                                                    <label for="brother' + t.coLength + '">Brother</label>\n' +
      '                                                </li>\n' +
      '                                                <li class="service-list">\n' +
      '                                                    <input type="radio" name="relation' + t.coLength + '" data-name="relation" id="sister' + t.coLength + '"\n' +
      '                                                           class="checkbox-input services co-field" value="Sister"/>\n' +
      '                                                    <label for="sister' + t.coLength + '">Sister</label>\n' +
      '                                                </li>\n' +
      '                                                <li class="service-list">\n' +
      '                                                    <input type="radio" name="relation' + t.coLength + '" data-name="relation" id="guardian' + t.coLength + '"\n' +
      '                                                           class="checkbox-input services co-field" value="Guardian"/>\n' +
      '                                                    <label for="guardian' + t.coLength + '">Guardian</label>\n' +
      '                                                </li>\n' +
      '                                            </ul>\n' +
      '                                        </div>\n' +
      '                                    </div>\n' +
      '                                    <div class="col-md-12 padd-20">\n' +
      '                                        <div class="form-group">\n' +
      '                                            <div class="radio-heading input-group-text">\n' +
      '                                                Your Co-Borrower\'s employment type ?\n' +
      '                                            </div>\n' +
      '                                            <ul class="displayInline">\n' +
      '                                                <li>\n' +
      '                                                    <label class="container-radio">Salaried\n' +
      '                                                        <input type="radio" checked="checked" name="employment_type' + t.coLength + '" data-name="employment_type" class="co-field" value="1">\n' +
      '                                                        <span class="checkmark"></span>\n' +
      '                                                    </label>\n' +
      '                                                </li>\n' +
      '                                                <li>\n' +
      '                                                    <label class="container-radio">Self-Employed\n' +
      '                                                        <input type="radio" name="employment_type' + t.coLength + '" data-name="employment_type" class="co-field" value="2">\n' +
      '                                                        <span class="checkmark"></span>\n' +
      '                                                    </label>\n' +
      '                                                </li>\n' +
      '                                                <li>\n' +
      '                                                    <label class="container-radio">Non-Working\n' +
      '                                                        <input type="radio" name="employment_type' + t.coLength + '" data-name="employment_type" class="co-field" value="0">\n' +
      '                                                        <span class="checkmark"></span>\n' +
      '                                                    </label>\n' +
      '                                                </li>\n' +
      '                                            </ul>\n' +
      '                                        </div>\n' +
      '                                    </div>\n' +
                                        // '<div class="col-md-12 padd-20">\n' +
                                        //   '<div class="form-group">\n' +
                                        //     '<label for="coAnnual_income" class="input-group-text">\n' +
                                        //       'Pan Card Number\n' +
                                        //     '</label>\n' +
                                        //     '<input type="text" class="form-control field-req co-field field-req" id="PanNumber" name="pan_number" data-name="pan_number" placeholder="Enter Pan Number">\n' +
                                        //   '</div>\n' +
                                        // '</div>\n' +
                                        // '<div class="col-md-12 padd-20">\n' +
                                        //   '<div class="form-group">\n' +
                                        //     '<label for="aadhaarNumber" class="input-group-text">\n' +
                                        //       'Aadhaar Card\n' +
                                        //     '</label>\n' +
                                        //     '<input type="text" class="form-control field-req co-field adhar" id="aadhaarNumber" name="aadhaar_number" data-name="aadhaar_number" placeholder="Enter Aadhaar Card">\n' +
                                        //   '</div>\n' +
                                        // '</div>\n' +
      '                                    <div class="col-md-12 padd-20">\n' +
      '                                        <div class="form-group">\n' +
      '                                            <label for="annulIncome" class="input-group-text">\n' +
      '                                                Co-Borrower\'s Annual Income\n' +
      '                                            </label>\n' +
      '                                            <input type="text" class="form-control co-field field-req" name="annual_income' + t.coLength + '" data-name="annual_income" id="annulIncome"\n' +
      '                                                   placeholder="Enter Annual Income">\n' +
      '                                        </div>\n' +
      '                                    </div>'];
      var textnode = document.createElement("div");
      textnode.setAttribute('class', 'coapplicant applicantsMultiple');
      textnode.innerHTML = coApplicant;
      document.getElementById('addAnotherCo').appendChild(textnode);

      // let coapplicants = document.getElementsByClassName('coapplicant');
      // if (coapplicants.length > 1) {
      //     document.getElementById('addAnotherButton').style.display = "none"
      // }
      t.coLength++;
      $(document).on('click', '.removeCo', function (e) {
        e.preventDefault();
        $(this).parent().parent().remove();
      });
    },
    getCourses() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/candhome/college-courses`, '', {
        headers: requestHeaders()
      }).then(function (response) {
        if (response['data']['response']['status'] == 200) {
          t.courses = response['data']['response']['courses'];
          // setTimeout(function () {
            // document.getElementsByName('college_course_enc_id')[0].value = t.$store.getters.getUser['course_enc_id'];
          // }, 2000);
        } else {
          t.getCourses();
        }
      })
          .catch(function (error) {
            t.getCourses();
          })
    },
    getFeeComponents() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/loans/fee-components`, '', {
        headers: requestHeaders()
      }).then(function (response) {
        if (response['data']['response']['status'] == 200) {
          t.fee_components = response['data']['response']['fee_components'];
          // t.loan_types = response['data']['response']['loan_types'];
          // setTimeout(function () {
          //     document.getElementsByName('loan_type_enc_id')[0].checked = true;
          // }, 1000);
        } else {
          // t.getFeeComponents();
        }
      })
          .catch(function (error) {
            t.getFeeComponents();
          })
    },
    validateUserAccess() {
      var t = this;
      var url = this.$store.getters.getDomain;

      axios.post(`${url}api/v2/loans/application-status`, '', {
        headers: requestHeaders()
      }).then(function (response) {
        if (response['data']['response']['status'] == 404) {
          t.matchHeight();
          t.showTab(t.currentTab);
          t.getCourses();
          t.getFeeComponents();
          setTimeout(function () {
            $(function () {
              $('.datepicker3').datepicker({
                autoclose: true,
                format: 'yyyy-mm-dd',
              });
            });
          }, 2000);
        } else {
          alert('You have already applied loan of this session, please wait for their reply');
          t.$router.push({path: '/dashboard/applied-loan'});
        }
      })
          .catch(function (error) {
            alert('your Internet Connection Unstable');
            location.reload();
          })
    },
    getInstructions() {
      // var loan_id;
      // var el_purpose = document.getElementsByName('loan_type_enc_id');
      // for (var k = 0; k < el_purpose.length; k++) {
      //     if (el_purpose[k].checked) {
      //         loan_id = el_purpose[k].value;
      //     }
      // }
      // var t = this;
      // var url = this.$store.getters.getDomain;
      // const headers = {
      //     'Authorization': "Bearer " + localStorage.getItem('token'),
      //     'source': localStorage.getItem('source'),
      //     'Content-Type': 'application/json'
      // };
      // axios.post(`${url}api/v2/loans/get-min-max`, {loan_type_enc_id:loan_id}, {
      //     headers: headers
      // }).then(function (response) {
      //     if (response['data']['response']['status'] == 200) {
      //         // t.loan_types = response['data']['response']['loan_types'];
      //     } else {
      //
      //     }
      // })
      //     .catch(function (error) {
      //
      //     })
    },
    updateApplication(paymentId,paymentSignature, eduLoanId, loanAppId,status) {
      var t = this;
      showLoader();
      var url = this.$store.getters.getDomain;

      var res = {};
      res['loan_app_id'] = loanAppId;
      res['loan_payment_id'] = eduLoanId;
      res['payment_id'] = paymentId;
      res['signature'] = paymentSignature;
      res['status'] = status;
      axios.post(`${url}api/v2/loans/update-loan-application`, res, {
        headers: requestHeaders()
      }).then(function (response) {
        if (response['data']['response']['status'] == 200) {
          toastr.success('Application Fees ' + res.status, 'Success');
          if(res.status != 'failed') {
              window.location.replace("/dashboard");
          }
          // t.$router.push({path: '/dashboard'});
        } else {
          // t.getFeeComponents();
        }
        hideLoader();
      })
          .catch(function (error) {
            // t.getFeeComponents();
          })
    },
  },
  mounted() {
    if (!this.$store.getters.getUser['education_loan']) {
      this.$router.push({path: '/dashboard'})
    }
    if (!document.getElementById('my-datepicker')) {
      var scriptTag = document.createElement("script");
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/css/datepicker.css';
      scriptTag.src = "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.3.0/js/bootstrap-datepicker.js";
      scriptTag.id = "my-datepicker";
      document.getElementsByTagName('head')[0].appendChild(link);
      document.getElementsByTagName('head')[0].appendChild(scriptTag);
    }
    var t = this;
    t.validateUserAccess();
      new Autocomplete('#course-list-main', {
          search: input => {
              const domain = this.$store.getters.getDomain
              const url = `${domain}api/v2/loans/college-courses?keyword=${encodeURI(input)}`
              return new Promise(resolve => {
                  if (input.length < 1) {
                      return resolve([])
                  }
                  fetch(url)
                      .then(response => response.json())
                      .then(data => {
                          resolve(data)
                      })
              })
          },
          renderResult: (result, props) => `
                  <li ${props}>
                    <div class="ss-description">
                      ${result.course_name}
                    </div>
                  </li>
              `,
          getResultValue: result => result.course_name,
          onSubmit: result => {
              // t.institute_name = result['name'];
              // t.college_selected = result['organization_enc_id'];
          }
  });
  },
}
</script>

<style scoped>
.form-heading {
  font-weight: bold;
  /*margin-top: 20px;*/
  /*border-top: 1px solid #eee;*/
  padding: 10px 0 5px 0;
}

.form-heading span {
  float: right;
  color: #00a0e3
}

#countryName {
  display: none;
}

.float-right {
  float: right;
  padding-top: 3px;
  color: #333 !important;
}

.addAnotherCo {
  background: none;
  border: none;
  margin-bottom: 20px;
}

.addAnotherCo:hover {
  color: #00a0e3;
  transition: .3s ease;
}

.displayInline li {
  display: inline-block;
  padding-right: 20px;
}

.cl-icon img {
  margin-top: 30px;
  max-height: 300px;
}

.form-start {
  max-width: 400px;
  margin: 0 auto;
}

.btn-center {
  text-align: center;
}

.btn-center button {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  padding: 13px 32px;
  border-radius: 4px;
  -o-transition: .3s all;
  -ms-transition: .3s all;
  -moz-transition: .3s all;
  -webkit-transition: .3s all;
  transition: .3s all;
  color: #222;
  box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
  margin-left: 5px;
  background: #fff;
  border: none;
}

.btn-center button:hover {
  background-color: #00a0e3;
  color: #fff;
}

.max-300 {
  max-width: 350px;
  margin: 0 auto;
}

.education-loan-form {
  padding: 20px 25px 0 25px;
  background: linear-gradient(to bottom, #e9f5f5 0%, #fefefe 100%);
  min-height: 100%;
  width: 50vw;
  position: absolute;
  min-height: 100vh;
}

.college-logo {
  margin-left: 50vw;
  padding: 60px 25px 0 25px;
  text-align: center;
  color: #000;
  width: 50vw;
  min-height: 100vh;
  position: fixed;
  background: #00a0e3;
}

@media only screen and (max-width: 991px) {
    .bg-blue{
        padding-top: 90px;
    }
}
@media only screen and (max-width: 500px) {
  .education-loan-form {
    width: 100vw;
  }

  .college-logo {
    display: none;
  }

  .cl-heading {
    font-size: 10px;
    display: none;
  }

  .cl-text {
    font-size: 8px;
    display: none;
  }

  .cl-icon img {
    margin-top: 35vh
  }
}

.cl-text {
  font-size: 16px;
  color: #fff
}

.cl-heading {
  color: #fff;
  font-size: 20px;
  padding-top: 30px;
  font-weight: bold;
}

.bg-white {
  background: #fff;
}

.radio-heading {
  padding-bottom: 10px;
}

.input-group {
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-control.invalid {
  border: 1px solid #ff0000;
}
.college-list{
    z-index: 99 !Important;
}
</style>